import React, { useEffect, useState, useCallback } from "react";
import "./CartPage.css";
import { Delete } from "@mui/icons-material";
import CouponModal from "./CouponModal";
import AddressSelectionModal from "./AddressSelectionModal"; // Import modal component
import LoginModal from "./LoginModal";
import AuthModal from "./AuthModal";
import {fetchWithAuth} from "../api/AuthApi.services"
import { toast, ToastContainer } from "react-toastify";
import {  getCartItems } from "../api/Product.services";
// import CustomToast from "./CustomToast";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

// Confirmation Modal Component
const ConfirmDeleteModal = ({ show, product, onConfirm, onCancel }) => {
  return (
    <Modal show={show} onHide={onCancel} centered dialogClassName="custom-modal-width">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to remove <strong >{product?.name || "this product"}</strong> from the cart?
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onCancel} className="me-2">
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const CartPage = ({ setCartItemsCount }) => {
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [couponId, setCouponId] = useState(0);
  // const [setModalStep] = useState("LOGIN");
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [addressList, setAddressList] = useState([]);
  // const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const navigate = useNavigate();

  const fetchAddresses = async (token) => {
    const response = await fetchWithAuth(`${API_BASE_URL}/account/addresses/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      return await response.json();
    }  else {
      console.error("Failed to fetch addresses");
      // alert("Failed to retrieve addresses. Please try again.");
      return null;
    }
  };

  const getAddressData = async () => {
    let accessToken = localStorage.getItem("accessToken");
    const addresses = await fetchAddresses(accessToken);
      if (!addresses) return;
      
      setAddressList(addresses);
      setShowAuthModal(false);
      setShowAddressModal(true);
  }


  const handleSuccess = (message) => {
    toast(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    });
  };

  const handleError = useCallback((message) => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }, []);

  const fetchProductDetails = useCallback(async (productId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/product/products/${productId}`);
      if (response.ok) {
        return await response.json();
      } else {
        console.error("Failed to fetch product details");
        return null;
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      handleError("Error fetching product details:");
      return null;
    }
  },[handleError]);

  const fetchCartData = useCallback(async () => {
    try {
      const guestUserId = localStorage.getItem("guest_user_id");
      const accessToken = localStorage.getItem("accessToken");
      const url = new URL(`${API_BASE_URL}/order/carts/`);
      let response;

      if (guestUserId) {
        url.searchParams.append("guest_user_id", guestUserId);
      }

      const headers = {
        "Content-Type": "application/json",
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
      if (accessToken) {
        response = await fetchWithAuth(url, {
          method: "GET",
          headers: headers,
        });
      } else{
        response = await fetch(url, {
          method: "GET",
          headers: headers,
        });
      }

      if (response.ok) {
        const data = await response.json();
        const activeCart = data.find((cart) => cart.is_active);
        if (activeCart) {
          const itemsWithDetails = await Promise.all(
            activeCart.items.map(async (item) => {
              const productDetails = await fetchProductDetails(item.product);
              return {
                ...item,
                productDetails,
              };
            })
          );
          setCartItems(itemsWithDetails);
          setTotalPrice(activeCart.total_price || 0);
        }
      } else {
        console.error("Failed to fetch cart items.");
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
      handleError("Error fetching cart items:");
    }
  }, [fetchProductDetails, handleError]);

  const handleAddQuantity = async (productId) => {
    try {
      const guest_user_id = localStorage.getItem("guest_user_id");
      const accessToken = localStorage.getItem("accessToken"); 
      let response;

      const headers = {
        "Content-Type": "application/json",
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
      const body = {
        product: productId,
      };
  
      if (guest_user_id) {
        body.guest_user_id = guest_user_id; // Add guest_user_id only if it exists
      }

      if(accessToken){
        response = await fetchWithAuth(`${API_BASE_URL}/order/carts/add-item/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      } else{
        response = await fetch(`${API_BASE_URL}/order/carts/add-item/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      }

      if (response.ok) {
        fetchCartData();
      } else {
        console.error("Failed to add item.");
      }
    } catch (error) {
      console.error("Error adding item:", error);
      handleError("Error adding item:");
    }
  };

  const handleReduceQuantity = async (productId) => {
    try {
      const guest_user_id = localStorage.getItem("guest_user_id");
      const accessToken = localStorage.getItem("accessToken");
      let response;

      const headers = {
        "Content-Type": "application/json",
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
      const body = {
        product: productId, // Sending the product ID
      };
  
      if (guest_user_id) {
        body.guest_user_id = guest_user_id; // Add guest_user_id only if it exists
      }
      if (accessToken) {
        response = await fetchWithAuth(`${API_BASE_URL}/order/carts/reduce-quantity/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      } else{
        response = await fetch(`${API_BASE_URL}/order/carts/reduce-quantity/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      }
      if (response.ok) {
        fetchCartData();
      } else {
        console.error("Failed to reduce quantity.");
      }
    } catch (error) {
      console.error("Error reducing quantity:", error);
      handleError("Error reducing quantity:");
    }
  };

  const handleRemoveProduct = async (productId) => {
    try {
      const guest_user_id = localStorage.getItem("guest_user_id");
      const accessToken = localStorage.getItem("accessToken"); 
      let response;

      const headers = {
        "Content-Type": "application/json",
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
      const body = {
        product: productId, // Sending the product ID
      };
  
      if (guest_user_id) {
        body.guest_user_id = guest_user_id; // Add guest_user_id only if it exists
      }
      if (accessToken) {
        response = await fetchWithAuth(`${API_BASE_URL}/order/carts/remove-item/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      } else {
        response = await fetch(`${API_BASE_URL}/order/carts/remove-item/`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });
      }
      if (response.ok) {
        fetchCartData();
        const updatedCart = await getCartItems();
        setCartItemsCount(updatedCart[0]?.items?.length || 0);
      } else {
        console.error("Failed to remove item.");
      }
    } catch (error) {
      console.error("Error removing item:", error);
      handleError("Error removing item:");
    }
  };


  const handleApplyCoupon = (newCoupon, prevCoupon) => {
    console.log(newCoupon, prevCoupon)
    setTotalPrice((prevPrice) => {
      console.log(prevPrice)
      let updatedPrice = prevPrice;

      if (prevCoupon) {
        console.log(prevCoupon.discount)
        updatedPrice += parseInt(prevCoupon.discount); // Re-add previous discount
      }

      console.log(updatedPrice)
      updatedPrice -= parseInt(newCoupon.discount) || 0; // Apply new discount
      // Ensure the subtotal never goes negative
      return Math.max(updatedPrice, 0);
    });
    setCouponId(newCoupon.id)
    setAppliedCoupon(newCoupon);

  };
  
  const handleProceedToCheckout = async () => {
    try {
      let accessToken = localStorage.getItem("accessToken") || null;
      let userDetails = localStorage.getItem("userDetails") || null;
      // const refreshToken = localStorage.getItem("refreshToken");
  
      // if (!accessToken) {
      //   console.log("access token not found ---------->");
      //   alert("Login first");
      //   return;
      // }

      if (accessToken === null && userDetails === null) {
        // setShowLoginModal(true);
        setShowAuthModal(true); 
        return;
      }

      const addresses = await fetchAddresses(accessToken);
      if (!addresses) return;
  
      // Open modal and pass addresses
      setAddressList(addresses);
      setShowAddressModal(true); // Open modal
    } catch (error) {
      console.error("Error during checkout:", error);
      // alert("Something went wrong. Please try again.");
      handleError("Error during checkout:");
    }
  };
  
  const handleAddressSelect = (addressId) => {
    if (!addressId) {
      console.log("addressId",addressId);
      return;
    }
    // console.log("addressId",addressId);
    // setSelectedAddressId(addressId);
    createOrder(addressId);
  };

  const createOrder = async (addressId) => {
    let accessToken = localStorage.getItem("accessToken");
    if (!addressId) {
      console.log("addressId",addressId);
      return;
    }
    console.log("addressId",addressId);
    let orderResponse;

    if(addressId != null) {
      orderResponse = await fetchWithAuth(
        `${API_BASE_URL}/order/orders/create_order/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            final_amount: totalPrice,
            notes: { description: "Order for VastuAura Aligners" },
            delivery_address: addressId, 
            coupon: couponId,
          }),
        }
      );
    }

    const orderData = await orderResponse.json();
    console.log("order data ------>", orderData)
    if (!orderResponse.ok) {
      // alert("Failed to initiate checkout. Please try again.");
      handleError(orderData.error || "Failed to initiate checkout. Please try again.");
      return;
    }
    
    initiatePayment(orderData);
  };

  const initiatePayment = (orderData) => {
    const { razorpay_order_id, email, username, contact } = orderData;

    const options = {
      key: "rzp_test_iJaCPWLLq7a6Xy",
      amount: totalPrice,
      currency: "INR",
      name: "VastuAura Aligners",
      description: "Payment for your order",
      order_id: razorpay_order_id,
      handler: async function (response) {
        handleSuccess(`"Payment successful! Payment ID: " + ${response.razorpay_payment_id}`)
        // alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
        recordPayment(response);
      },
      prefill: { name: username, email: email, contact: contact },
      theme: { color: "#3399cc" },
    };

    const razorpayInstance = new window.Razorpay(options);
    razorpayInstance.open();

    razorpayInstance.on("payment.failed", function (response) {
      // alert("Payment failed. Please try again.");
      console.error("Payment Failure Response:", response.error);
      recordPayment(response, "FAILED");
    });
  };

  const recordPayment = async (response, status = "COMPLETED") => {
    let accessToken = localStorage.getItem("accessToken");

    const paymentResponse = await fetchWithAuth(
      `${API_BASE_URL}/payment/create_payment/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          amount: totalPrice,
          payment_status: status,
        }),
      }
    );

    if (!paymentResponse.ok) {
      console.error("Failed to record payment");
      // alert("Payment recorded failed. Please contact support.");
      handleError("Payment recorded failed. Please contact support.");
    } else {
      // alert("Payment recorded successfully!");
      handleSuccess("Payment recorded successfully!")
      const updatedCart = await getCartItems();
      setCartItemsCount(updatedCart[0]?.items?.length || 0);
      fetchCartData();
      navigate("/orders");
    }
  };

  // console.log('cartItems',cartItems);


  useEffect(() => {
    fetchCartData();
  }, [fetchCartData]);

  return (
    // <div className="cart-page">
    <div className="container mt-5 mb-5">
      <ToastContainer />
      <h2 className="cart-title">Shopping Cart</h2>
      {cartItems.length > 0 ? (
        <>
         <div className="row mt-4 justify-content-center align-items-center mb-5">
          <div className="col-lg-8 mt-4">
            <div className="cart-items">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th>Total</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item) => (
                    <tr key={item.id}>
                      <td className="product-info">
                        <img
                          className="product-image-cart"
                          src={`${item.productDetails?.documents?.[0]?.picture || ""}`}
                          alt={item.productDetails?.name || "Product"}
                        />
                        <div className="product-details">
                          <h4>{item.productDetails?.name || "Product Name"}</h4>
                          {/* <p>{item.productDetails?.category?.name || "Category"}</p> */}
                          <p>₹{item.productDetails?.actual_unit_price || ""}</p>
                        </div>
                      </td>
                      <td>
                        <div className="quantity-container">
                          <button
                            className="quantity-btn"
                            onClick={() => handleReduceQuantity(item.product)}
                            disabled={item.quantity <= 1}
                          >
                            -
                          </button>
                          <span className="quantity">{item.quantity}</span>
                          <button
                            className="quantity-btn"
                            onClick={() => handleAddQuantity(item.product)}
                            disabled={item.quantity >= 10}
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td>₹{item.total_price.toFixed(2)}</td>
                      <td>
                        {/* <Delete
                          className="delete-icon"
                          onClick={() => handleRemoveProduct(item.product)}
                        /> */}
                        <Delete
                          className="delete-icon"
                          onClick={() =>
                            setProductToDelete({
                              id: item.product,
                              name: item.productDetails?.name,
                            }) || setShowConfirmModal(true)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-lg-4 mt-4">
            <div className="cart-summary-row">
              <div className="summary-content">
                <h3>Subtotal: ₹{totalPrice.toFixed(2)}</h3>
                {appliedCoupon && <p>Applied Coupon: {appliedCoupon.code}</p>}
                <button className="checkout-button" onClick={() => setCouponModalOpen(true)}>
                  Apply coupon
                </button>
                <button
                  className="checkout-button"
                  onClick={handleProceedToCheckout}
                >
                  Checkout
                </button>
              </div>
              <CouponModal
                open={couponModalOpen}
                onClose={() => setCouponModalOpen(false)}
                onApplyCoupon={handleApplyCoupon}
                appliedCoupon={appliedCoupon}
                totalPrice={totalPrice} // Pass totalPrice
              />

            {showAddressModal && (
              <AddressSelectionModal
                addresses={addressList}
                onSelect={handleAddressSelect}
                onClose={() => setShowAddressModal(false)}
              />
            )}

          {showLoginModal && (
            <LoginModal
              onClose={() => setShowLoginModal(false)}
              onLoginSuccess={handleProceedToCheckout} // Continue checkout after login
            />
          )}
            </div>
          </div>
         </div>
        </>
      ) : (
        <>
         <div className="row mt-4 justify-content-center align-items-center mb-5">
          <div className="col-lg-8 mt-4">
            <div className="cart-items">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th>Total</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                <tr className="text-center">
                  <td colSpan="4">
                    <p className="empty-cart-message text-center">Your cart is empty.</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
         </div>
        </>
      )}
       {/* AuthModal for Login/Register */}
      <AuthModal 
        show={showAuthModal} 
        onClose={getAddressData}
        onCloseModel={()=>{setShowAuthModal(false)}}
        onLoginSuccess={fetchCartData} 
        redirectFrom = {"cartPage"}
      />
      <ConfirmDeleteModal
        show={showConfirmModal}
        product={productToDelete}
        onConfirm={() => {
          handleRemoveProduct(productToDelete?.id);
          setShowConfirmModal(false);
        }}
        onCancel={() => {
          setShowConfirmModal(false);
          setProductToDelete(null);
        }}
      />
    </div>
  );
};

export default CartPage;
